// 订单管理模块国际化 - 中文
import formEngine from './order-form-engine'
import clientDetail from './order-client-detail'

export default {
  title: '订单管理',

  // 字段
  orderNo: '订单编号',
  customerName: '客户名称',
  orderAmount: '订单金额',
  transportType: '运输类型',
  origin: '起运地',
  destination: '目的地',
  estimatedDelivery: '预计送达',
  amountRange: '金额范围',
  createDateRange: '创建日期',
  orderType: '订单类型',
  quoteNo: '报价单号',
  cargoJobNo: 'Cargo业务编号',
  customReferenceNo: '业务参考号',
  mblNo: 'MBL单号',
  hblNo: 'HBL单号',
  containerNo: '箱号',

  // 状态
  status: {
    pending: '待确认',
    confirmed: '已确认',
    inTransit: '运输中',
    completed: '已完成',
    cancelled: '已取消'
  },

  // 运输类型
  transportTypes: {
    sea: '海运',
    air: '空运',
    rail: '铁运',
    road: '公路'
  },

  // 订单类型
  types: {
    needQuote: '需要报价',
    hasQuote: '已有报价',
    booking: '代订舱'
  },

  // 操作
  actions: {
    createOrder: '新增订单',
    placeOrder: '下单',
    exportData: '导出数据',
    customizeTable: '自定义表格',
    syncOrder: '同步订单',
    triggerSync: '主动同步选中订单',
    view: '查看',
    delete: '删除',
    editDraft: '继续编辑'
  },

  unifiedCreate: {
    clientTitle: '委托下单',
    adminTitle: '代客下单',
    editDraftTitle: '编辑草稿',
    subtitle: '表单引擎消费端',
    businessTypeLabel: '业务类型：',
    formTitle: '表单信息 · {name}',
    templateReady: '模板就绪',
    templateMissing: '模板待完善',
    noTemplateHint: '该业务类型尚未配置表单模板，请先在平台管理端创建并发布对应业务类型的模板。',
    saveDraft: '保存草稿',
    submitOrder: '提交订单',
    draftSaved: '草稿已保存',
    submitSuccess: '下单成功',
    validationFailed: '表单校验未通过，请按标红提示修改',
    validationRequiredFailed: '请填写所有必填项（标红处）',
    validationRequestFailed: '表单校验失败，请稍后重试',
    echoLoadFailed: '加载订单数据失败，请刷新后重试',
    selectBusinessHint: '请先选择上方业务类型开始下单',
    attachmentTitle: '附件',
    attachmentTip: '支持 PDF/JPG/PNG/DOC，最多 10 个文件',
    sourceBannerText: '已从「{label}」带入数据 · {keyLabel} {keyValue}',
    clearSource: '清除来源',
    sourceCleared: '已清除来源数据，可切换业务类型或手工填写',
    retry: '重试',
    manualFill: '手工填写',
    switchedToManual: '已切换为手工填写',
    bizLockedHint: '已从来源带入数据，如需切换业务类型请先「清除来源」',
    notIntegratedHint: '「{biz}」业务的来源数据暂未接入，请手动填写',
    estimatedTotalFee: '预估总费用',
    mixedCurrency: '含多币种',
    viewFeeDetail: '显示详情'
  },
  sourceAdapter: {
    rateQuery: '运价查询',
    quoteRecord: '报价记录',
    inquiry: '询报价',
    quotation: '报价管理',
    specialPrice: '特价申请',
    shareQuote: '分享报价',
    rateNo: '运价编号',
    inquiryNo: '询价单号'
  },

  // 服务项目（委托下单表单）
  serviceItems: {
    fieldLabel: '服务项目',
    sectionTitle: '服务项目',
    placeholder: '请选择服务项目',
    BOOKING_SERVICE: '订舱服务',
    TRUCKING_SERVICE: '拖车服务',
    STUFFING_SERVICE: '内装服务',
    INSURANCE_SERVICE: '保险服务',
    CUSTOMS_SERVICE: '报关服务',
    DESTINATION_EXCHANGE_ORDER_SERVICE: '目的港换单服务',
    DESTINATION_WAREHOUSING_SERVICE: '目的港仓储服务',
    DESTINATION_DELIVERY_SERVICE: '目的港派送服务',
    DESTINATION_CUSTOMS_CLEARANCE_SERVICE: '目的港清关服务'
  },

  formEngine,
  clientDetail,

  // 统一订单业务类型（列表 Tab / 列展示）
  businessType: {
    FCL: 'FCL 海运整箱',
    LCL: 'LCL 海运拼箱',
    AIR: 'AIR 空运',
    RAIL: 'RAIL 铁路',
    TRUCK: 'TRUCK 汽运',
    LTL: 'LTL 零担',
    TRAILER: 'TRAILER 拖车',
    RORO: 'RORO 滚装',
    BULK: 'BULK 散货'
  },

  // 订单详情头/业务类型短标签（不带运输方式前缀）
  businessTypeShort: {
    FCL: '海运整箱',
    LCL: '海运拼箱',
    AIR: '空运',
    RAIL: '铁路',
    TRUCK: '汽运',
    LTL: '零担',
    TRAILER: '拖车',
    RORO: '滚装',
    BULK: '散货'
  },

  // 业务字段抽屉
  businessFieldsDrawer: {
    title: '业务字段 · {orderNo}',
    businessType: '业务类型',
    viewAction: '查看字段',
    viewJson: '查看 JSON',
    hideJson: '隐藏 JSON',
    empty: '暂无业务字段'
  },

  // 导出相关
  export: {
    mode: '导出模式',
    modeSelected: '选中数据',
    modeFiltered: '全量筛选数据',
    modeCurrentPage: '当前页数据',
    successTitle: '导出任务已提交',
    jumpPrompt: '任务处理中，是否进入任务中心查看进度？',
    goToTaskManager: '进入任务中心',
    taskManagerRedirectTitle: '任务中心',
    jumpCancel: '留在本页',
    csvSuccess: 'CSV 导出成功',
    excelSuccess: 'Excel 导出成功',
    csvFailed: 'CSV 导出失败',
    excelFailed: 'Excel 导出失败',
    exportSuccess: '导出成功',
    noDataToExport: '暂无导出数据',
    filename: '订单导出数据',
    sheetTitle: '订单表格数据'
  },

  // 表单
  forms: {
    orderNoPlaceholder: '请输入订单编号',
    statusPlaceholder: '请选择状态',
    businessTypePlaceholder: '请选择业务类型',
    transportTypePlaceholder: '请选择运输类型',
    customerNamePlaceholder: '请输入客户名称',
    minAmount: '最小金额',
    maxAmount: '最大金额',
    orderTypeRequired: '请选择订单类型',
    quoteNoRequired: '请输入报价单号',
    quoteNoPlaceholder: '请输入报价单号',
    cargoJobNoPlaceholder: '请输入Cargo业务编号',
    customReferenceNoPlaceholder: '请输入业务参考号',
    mblNoPlaceholder: '请输入MBL单号',
    hblNoPlaceholder: '请输入HBL单号',
    containerNoPlaceholder: '请输入箱号',
    polPlaceholder: '请选择起运港',
    podPlaceholder: '请选择目的港',
    podSeaPlaceholder: '请选择卸货港',
    carrierPlaceholder: '请选择船公司',
    vesselVoyagePlaceholder: '请输入船名航次',
    orderStatusPlaceholder: '请选择订单状态',
    orderTypePlaceholder: '请选择订单类型',
    etdPlaceholder: '请选择ETD范围',
    etaPlaceholder: '请选择ETA范围',
    laneCodePlaceholder: '请选择航线代码',
    cutoffTimePlaceholder: '请选择截关时间范围',
    transitPortsPlaceholder: '请选择中转港',
    bookingNoPlaceholder: '请输入订舱号',
    amsNoPlaceholder: '请输入AMS No',
    isfNoPlaceholder: '请输入ISF No',
    orderType: '订单类型',
    clientId: '委托单位',
    clientIdPlaceholder: '请选择委托单位',
    clientIdRequired: '请选择委托单位',
    quoteNoLabel: '报价单号',
    quoteNoInputPlaceholder: '请输入报价单号'
  },

  // AI助手
  aiAssistant: {
    title: 'AI订单助手',
    welcomeMessage: '您好！我是订单管理AI助手，可以帮您查询订单状态、分析运输趋势、优化物流方案等。请问有什么可以帮您的吗？',
    inputPlaceholder: '请输入您的问题...',
    send: '发送',
    mockResponse: '您问的是"{question}"，这是一个非常好的问题。AI功能正在开发中，敬请期待！'
  },

  // 枚举
  enum: {
    transportMode: {
      FCL: '整箱',
      LCL: '拼箱'
    },
    status: {
      draft: '草稿',
      inProgress: '进行中',
      completed: '已完成',
      cancelled: '已取消'
    },
    type: {
      sea: '海运订单',
      air: '空运订单',
      land: '陆运订单',
      rail: '铁路订单'
    },
    createType: {
      needQuote: '需要报价',
      hasQuote: '已有报价',
      booking: '代订舱'
    },
    // 订单来源：CW=CargoWare 入站同步，CWX=本系统 CargoWareX 自建
    orderSource: {
      cw: 'CargoWare',
      cwx: 'CargoWareX',
      cwTip: '该票由 CargoWare 录入同步，改单请回 CargoWare 处理'
    },
    nodeTaskStatus: {
      incomplete: '未完成',
      partial: '部分完成',
      completed: '已完成'
    },
    // SOP 业务节点状态类型，取值语义与 CargoWare stateType 对齐（CCTOWER-3288）
    sopStateType: {
      notStarted: '未开始',
      inProgress: '进行中',
      completed: '已完成',
      exception: '异常'
    },
    taskStatus: {
      notStarted: '未开始',
      inProgress: '进行中',
      completed: '已完成',
      skipped: '已跳过',
      paused: '已暂停'
    },
    taskType: {
      customer: '客户任务',
      operation: '运营任务'
    },
    priority: {
      low: '低',
      medium: '中',
      high: '高',
      urgent: '紧急'
    },
    partyType: {
      shipper: '发货人',
      consignee: '收货人',
      notify: '通知人',
      customsShipper: '报关发货地址',
      customsConsignee: '报关收货地址',
      clearanceShipper: '清关发货地址',
      clearanceConsignee: '清关收货地址',
      actualPickup: '实际提货地',
      actualDelivery: '实际送达地',
      notify2: '通知人2'
    },
    chassisAbnormalStatus: {
      all: '全部',
      hasAbnormal: '有',
      noAbnormal: '无'
    },
    syncStatus: {
      notSynced: '未同步',
      syncing: '同步中',
      synced: '已同步',
      syncFailed: '同步失败',
      preReviewRejected: '预审驳回'
    },
    cargoType: {
      general: '普货',
      dangerous: '危险品',
      reefer: '冷冻品',
      special: '特种箱',
      steelCoil: '卷钢',
      liquid: '液体',
      chemical: '化工品',
      textile: '纺织品',
      reeferDangerous: '冷危品'
    },
    releaseType: {
      original: '正本',
      telex: '电放',
      switch: '导地提单',
      seawaybill: '海运单',
      destinationRelease: '目的港放单',
      pending: '待定',
      notifyRelease: '等通知放单',
      ebl: '电子提单'
    },
    widgetType: {
      textbox: '文本框',
      dropdown: '下拉框'
    },
    orderFileType: {
      draftBillOfLading: '提单草单',
      originalBillOfLading: '提单正本',
      telexReleaseGuarantee: '电放保函',
      customsDeclaration: '报关单',
      draftCustomsDeclaration: '报关草单',
      releaseNotice: '放行通知书',
      customsDeclarationCopy: '报关底单',
      preTaxDocument: '预税单',
      officialTaxDocument: '正式税单',
      cargoRelated: '货物相关文件',
      certificationReport: '认证报告',
      supplierUpload: '供应商上传文件',
      sixCopyForm: '六联单',
      customsTransitAdvanceReleaseForm: '转关提前验放单',
      customsTransitAdvanceDeclarationForm: '转关提前申报单'
    },
    spaceStatus: {
      1: '畅接',
      2: '正常',
      3: '单票申请',
      4: '爆舱',
      5: '不接',
      6: '紧张',
      7: '停航',
      8: '询盘'
    }
  },

  // 消息提示
  messages: {
    searchSuccess: '搜索成功',
    searchFailed: '搜索失败',
    createSuccess: '订单创建成功',
    createFailed: '订单创建失败',
    editPending: '编辑订单 {orderNo} 功能开发中...',
    deletePending: '删除订单 {orderNo} 功能开发中...',
    deleteSuccess: '删除订单：{orderNo}成功',
    deleteFailed: '删除订单：{orderNo}失败',
    deleteFailedWithReason: '删除订单 {orderNo} 失败: {reason}',
    confirmDelete: '确认要删除订单 {orderNo} 吗？',
    onlyDraftCanDelete: '只有草稿状态的订单才能删除',
    exportPending: '导出功能开发中...',
    customizeTablePending: '自定义表格功能开发中...',
    loadDataFailed: '加载订单数据失败',
    queryQuoteFailed: '查询报价记录失败',
    triggerSyncSuccess: '成功触发 {count} 个订单的同步',
    triggerSyncFailed: '触发同步失败',
    selectOrdersFirst: '请先选择要同步的订单',
    selectPlatform: '请选择第三方平台',
    selectSyncMode: '请选择至少一种同步模式',
    syncSuccess: '同步成功！',
    syncSuccessTitle: '🎉 同步成功！',
    newOrders: '新增订单：',
    updateOrders: '更新订单：',
    tickets: '票',
    unknown: '未知',
    typePrefix: '类型',
    statusPrefix: '状态',
    priorityPrefix: '优先级',
    nodePrefix: '节点'
  },

  // 表格列
  columns: {
    orderNo: '订单编号',
    pol: '起运港',
    pod: '目的港',
    podSea: '卸货港',
    pdl: '目的港',
    carrier: '船公司',
    vesselName: '船名航次',
    etd: 'ETD',
    createdBy: '创建人',
    dateCreated: '创建时间',
    cargoJobNo: 'Cargo业务编号',
    mblNo: 'MBL单号',
    hblNo: 'HBL单号',
    containerNos: '箱号',
    actions: '操作',
    syncStatus: '订单同步状态',
    customReferenceNo: '业务参考号',
    eta: 'ETA',
    laneCode: '航线代码',
    terminal: '码头',
    cutoffTime: '截关时间',
    transitPorts: '中转港',
    voyageDays: '预计航程',
    containerDetails: '箱型箱量',
    bookingNo: '订舱号',
    amsNo: 'AMS No',
    isfNo: 'ISF No',
    shippingTerms: '运输条款',
    status: '订单状态',
    orderSource: '订单来源',
    sourceCode: '来源编号',
    businessType: '业务类型',
    businessFields: '业务字段'
  },

  // 任务相关（顶层，用于独立的任务页面）
  tasks: {
    // 提单补料页面
    blAddition: {
      title: '提单补料 - {orderNo}',
      back: '返回',
      aiRecognition: 'AI识别',
      generateGuarantee: '保函生成',
      rules: '规则提示',
      saveDraft: '暂存草稿',
      submit: '提交补料',
      guide: {
        title: '提单补料指南',
        tips: {
          title: '填写提示：',
          tip1: '发货人和收货人必须填写完整的公司名称和详细地址',
          tip2: '货物描述必须与实际货物一致，并使用英文填写',
          tip3: '重量和尺寸必须准确填写，单位需标明',
          tip4: '集装箱号格式需正确，例如：1*20GP，2*40HQ等',
          tip5: '建议使用AI识别功能快速导入信息'
        },
        errors: {
          title: '常见错误：',
          error1: '提单信息与订舱单不一致',
          error2: '发货人/收货人信息不完整',
          error3: '重量与货物描述不匹配',
          error4: '危险品信息缺失或不准确'
        },
        iKnow: '我知道了'
      },
      validation: {
        title: '提单补料校验提示',
        mandatoryRules: '强制校验规则',
        mandatoryRulesDesc: '以下规则必须满足，否则可能导致提单无法正常处理：',
        softRules: '软性提示规则',
        softRulesDesc: '以下为最佳实践建议，有助于提高提单处理效率：',
        columns: {
          field: '字段名',
          message: '校验提示'
        },
        cancel: '继续修改',
        confirmSubmit: '确认提交',
        rules: {
          blTypeRequired: '提单类型不能为空',
          mblNoRequired: '主单号不能为空',
          shipperRequired: '发货人不能为空',
          consigneeRequired: '收货人不能为空',
          vesselRequired: '船名不能为空',
          voyageRequired: '航次不能为空',
          polRequired: '起运港不能为空',
          portOfDischargeRequired: '卸货港不能为空',
          descriptionRequired: '货物品名不能为空',
          piecesMin: '件数必须大于0',
          containerInfoRequired: '集装箱信息不能为空',
          brazilTaxId: '目的港为巴西港口（代码BR开头），必须提供收货人VAT税号',
          notifyPartySame: '不能为空，如与收货人相同，请填写"SAME AS CONSIGNEE"',
          dangerousGoodsInfo: '危险品必须标注IMO危险品等级和UN编号',
          shipperAddressInfo: '建议填写完整公司名称及地址，包含邮编和国家',
          consigneeEnglish: '使用英文填写，避免使用特殊字符和缩写'
        }
      },
      aiModal: {
        title: 'AI识别',
        uploadTitle: '上传提单文件进行AI识别',
        uploadTip: '支持JPG、PNG、PDF格式，文件大小不超过10MB',
        clickOrDrag: '点击或拖拽上传',
        pdfFormat: 'PDF格式',
        recognizing: '识别中...',
        startRecognition: '开始识别',
        resultComparison: '识别结果对比',
        acceptAll: '接受全部',
        rejectAll: '拒绝全部',
        cancel: '取消'
      },
      guaranteeModal: {
        title: '选择保函类型',
        description: '请选择需要生成的保函类型（可多选）：',
        cancel: '取消',
        generate: '生成保函'
      },
      fields: {
        shipper: '发货人(Shipper)',
        consignee: '收货人(Consignee)',
        notifyParty: '通知方(Notify Party)',
        blType: '提单类型：',
        original: '正本(Original)',
        surrendered: '电放(Surrendered)',
        seaWaybill: '海运单(SEA WAYBILL)',
        blNo: '提单号(B/L NO.)',
        blAgent: '订舱代理(B/L Agent)',
        forwardingAgent: '代理商(Forwarding Agent)',
        masterBlNo: '主提单号(Master B/L NO.)',
        placeOfLoading: '装运地(Place of Loading)',
        placeOfLoadingPlaceholder: '请选择装运地',
        placeOfIssue: '签发地点(Place of Issue)',
        countryOfOrigin: '原产地(Country of Origin)',
        countryOfOriginPlaceholder: '请选择原产地',
        remark: '提单备注(Remark)',
        vessel: '船名',
        voyage: '航次',
        tradeTerms: '运输条款',
        tradeTermsPlaceholder: '请选择运输条款',
        placeOfReceipt: '收货地',
        placeOfReceiptPlaceholder: '请选择收货地',
        pol: '起运港',
        polPlaceholder: '请选择起运港',
        pod: '卸货港',
        podPlaceholder: '请选择卸货港',
        placeOfDelivery: '交货地',
        placeOfDeliveryPlaceholder: '请选择交货地',
        hsCode: 'HS编号',
        grossWeight: '毛重',
        grossWeightUnit: '(Gross Weight)',
        measurement: '尺寸',
        measurementUnit: '(Measurement)',
        pieces: '件数',
        piecesUnit: '(No.of Pkgs)',
        piecesType: '件数类型',
        piecesTypeUnit: '(Pieces Type)',
        piecesTypePlaceholder: '请选择件数类型',
        description: '货物描述',
        descriptionUnit: '(Description)',
        marks: '唛头',
        marksUnit: '(Marks)',
        containerNo: '箱号',
        containerType: '箱型',
        sealNo: '封号',
        containerWeight: '箱重',
        containerPieces: '件数',
        containerWeightField: '重量',
        containerCubage: '体积(CBM)',
        addContainer: '添加集装箱',
        removeContainer: '删除集装箱',
        blQuantity: '提单数量',
        blWay: '提单方式',
        issueDate: '签发日期',
        issueDatePlaceholder: '请选择签发日期',
        portRequirements: '港口要求',
        portRequirementsPlaceholder: '装箱单要求:\n原产地证明:'
      },
      messages: {
        saveDraftFailed: '无法暂存：未找到任务信息',
        validationFailed: '数据验证失败:\n{errors}',
        saveDraftSuccess: '暂存成功',
        uploadFileFirst: '请先上传文件',
        aiRecognitionComplete: 'AI识别完成',
        acceptAllResults: '已接受全部识别结果',
        rejectAllResults: '已拒绝全部识别结果',
        selectGuaranteeType: '请至少选择一种保函类型',
        guaranteeGenerated: '已生成 {count} 份保函',
        taskInstanceIdNotExists: '任务实例ID不存在',
        submitSuccess: '提单补料已提交成功',
        submitFailed: '提交失败，请重试',
        getTaskDataFailed: '获取任务数据失败'
      }
    },

    // BC件上传页面
    bcUpload: {
      title: 'BC上传 - 订单号: {orderId}',
      pageTitle: 'BC件上传',
      back: '返回',
      uploadTitle: 'BC件上传',
      dragText: '拖拽文件到此处，或点击上传',
      supportedFormats: '支持 PDF、JPG、PNG、DOC、DOCX 格式',
      fileSizeLimit: '文件大小不超过 10MB',
      uploadTip: '请上传清晰的BC件文档，系统将自动识别关键信息',
      verification: {
        title: '信息核对校验',
        filePreview: '文件预览',
        viewOriginal: '查看原文件',
        recognizedFields: '识别数据字段',
        systemFields: '系统已有字段',
        reupload: '重新上传',
        confirm: '确认无误',
        success: 'BC件处理完成'
      },
      fields: {
        shipper: '发货人(Shipper)',
        consignee: '收货人(Consignee)',
        notifyParty: '通知方(Notify Party)',
        vessel: '船舶(Vessel)',
        voyage: '航次(Voyage)',
        portOfLoading: '装货港(Port of Loading)',
        portOfDischarge: '卸货港(Port of Discharge)'
      }
    }
  },

  // 订单详情页面
  detail: {
    title: '订单详情',
    copy: '复制',
    close: '关闭',
    back: '返回',

    // 任务相关
    tasks: {
      unfinished: '未完成任务',
      completed: '已完成任务',
      deadline: '截止时间',
      taskName: '任务名称',
      taskType: '任务类型',
      executor: '执行人',
      taskStatus: '任务状态',
      pending: '待定',
      unassigned: '待分配',
      system: '系统',
      process: '处理',
      skip: '跳过',
      view: '查看',
      generatedAt: '生成于',
      completedAt: '完成于',
      noUnfinishedTasks: '暂无未完成任务',
      noCompletedTasks: '暂无已完成任务'
    },

    // 标签页
    tabs: {
      messageBoard: '留言板',
      overview: '概览',
      files: '文件'
    },

    viewTemplate: {
      title: '业务详情'
    },

    // 协作方信息
    collaborators: {
      title: '协作方联系信息',
      role: '角色',
      name: '姓名',
      phone: '电话',
      email: '邮箱',
      company: '公司',
      noCollaborators: '暂无协作方信息'
    },

    // 留言功能
    message: {
      placeholder: '请输入你的留言',
      send: '发送',
      attachment: '附件上传',
      noMessages: '暂无留言消息',
      sending: '发送中...',
      sendSuccess: '留言发送成功',
      sendFailed: '留言发送失败',
      developing: '留言功能开发中...'
    },

    // 基本信息
    basicInfo: {
      title: '基本信息',
      vesselName: '船名',
      carrier: '承运人',
      terminal: '码头',
      cutoffTime: '截关时间',
      etd: 'ETD',
      eta: 'ETA',
      voyage: '航次',
      orderType: '订单类型',
      orderStatus: '订单状态',
      priority: '优先级',
      dateCreated: '订单创建时间',
      createdBy: '创建人',
      serviceCode: '航线代码',
      portCallCode: '进港代码',
      edit: '编辑',
      save: '保存',
      print: '打印',
      cancel: '取消',
      placeholders: {
        vesselName: '请输入船名',
        voyage: '请输入航次',
        carrier: '请选择承运人',
        serviceCode: '请输入航线代码',
        terminal: '请选择码头',
        portCallCode: '请输入进港代码',
        etd: '请选择预计离港时间',
        eta: '请选择预计到港时间',
        cutoffTime: '请选择截关时间'
      },
      confirmCancel: {
        title: '确认取消',
        content: '数据有变动，取消后将丢失本次修改内容，是否确认取消？',
        okText: '确认取消',
        cancelText: '继续编辑'
      }
    },

    // 路径信息
    routeInfo: {
      title: '路径信息',
      pol: '起运港',
      pod: '卸货港',
      pdl: '目的港',
      pot1: '中转港',
      pot2: '中转港2',
      transitTime: '预计航程',
      shippingTerms: '运输条款',
      transportMode: '运输模式',
      days: '天',
      placeholders: {
        pol: '请选择起运港',
        pod: '请选择卸货港',
        pdl: '请选择目的港',
        pot1: '请选择中转港1',
        pot2: '请选择中转港2',
        transitTime: '请输入预计航程',
        shippingTerms: '请选择运输条款',
        transportMode: '请选择运输模式'
      }
    },

    // 货物信息
    cargoInfo: {
      title: '货物信息',
      cargoName: '货物名称',
      quantity: '件数',
      unit: '单位',
      grossWeight: '毛重',
      volume: '体积',
      cargoType: '类型',
      details: '明细',
      dangerousGoods: '危险品',
      view: '查看',
      noCargoInfo: '暂无货物信息',
      placeholders: {
        cargoName: '请输入货物名称',
        quantity: '请输入件数',
        unit: '请选择单位',
        grossWeight: '请输入毛重',
        volume: '请输入体积',
        cargoType: '请选择类型'
      }
    },

    // 集装箱信息
    containerInfo: {
      title: '集装箱信息',
      containerNo: '箱号',
      sealNo: '封号',
      containerType: '箱型',
      tareWeight: '皮重',
      containerStatus: '箱属',
      loadingPhotos: '装箱照片',
      noContainerInfo: '暂无集装箱信息',
      unit: 'KGS'
    },

    // 参考编号
    referenceNumbers: {
      title: '参考编号',
      orderNo: '订单号',
      customNo: '自定义编号',
      bookingNo: '订舱号',
      mblNo: 'MBL单号',
      hblNo: 'HBL单号',
      amsNo: 'AMS No',
      isfNo: 'ISF No',
      customReferenceNo: '业务参考号'
    },

    // 关联方信息
    relatedParties: {
      title: '关联方信息',
      partyType: '类型',
      companyName: '抬头',
      contactPerson: '联系人',
      address: '地址',
      phone: '电话',
      email: '邮箱',
      noRelatedParties: '暂无关联方信息'
    },

    // 文件管理
    files: {
      title: '文件',
      searchPlaceholder: '搜索文件名称...',
      nodeFilter: '节点筛选',
      downloadAll: '下载全部',
      fileName: '文件名',
      uploadedBy: '上传人',
      uploadTime: '上传时间',
      download: '下载',
      delete: '删除',
      deleteConfirm: '确定删除文件「{fileName}」吗？',
      downloadFailed: '文件下载失败',
      deleteFailed: '文件删除失败',
      noFiles: '暂无文件',
      fileTypeFallback: '文件',
      fileType: '文件类型',
      sourceFilter: '来源',
      sourceSystem: '系统单证',
      sourceUpload: '上传文件',
      systemSection: '系统单证',
      uploadSection: '上传文件',
      itemCount: '{count} 项',
      preview: '预览',
      previewTitle: '文件预览',
      previewUnavailable: '此文件类型暂不支持预览，请下载查看',
      previewFailed: '文件预览失败',
      upload: '上传文件',
      noSystemDocs: '暂无系统单证',
      noUploadDocs: '暂无上传文件',
      uploadModalTitle: '上传文件',
      uploadFileType: '文件类型',
      uploadFileTypePlaceholder: '请选择文件类型',
      uploadFileLabel: '文件',
      selectFile: '选择文件',
      uploadFilePlaceholder: '请选择要上传的文件',
      uploadSuccess: '文件上传成功',
      uploadFailed: '文件上传失败',
      fileTypeRequired: '请选择文件类型',
      fileRequired: '请选择要上传的文件',
      orderIdMissing: '订单ID不存在，无法上传文件',
      queryFailed: '文件查询失败',
      retry: '重试',
      clientLocked: '订单已预审，客户端不能再上传或删除文件'
    },

    // 节点筛选
    nodeFilter: {
      booking: '订舱',
      customs: '报关',
      trucking: '拖车',
      warehouse: '仓库',
      vgm: 'VGM',
      blAddition: '补料'
    },

    // 业务节点
    workflowNodes: {
      title: '业务节点',
      shippingNodes: '运踪节点',
      business: '业务节点',
      shipping: '运踪节点',
      noNodes: '暂无业务节点信息',
      noDetails: '暂无明细',
      noShippingNodes: '运踪节点功能开发中...',
      noTasks: '暂无任务信息',
      expand: '展开节点区域',
      collapse: '收起节点区域',
      node: '节点',
      subNode: '子节点'
    },
    feeDelete: {
      title: '确认删除',
      cancel: '取消',
      confirm: '确认删除',
      message: '确认要删除费用 <strong>{feeName}</strong> 吗？此操作不可恢复。'
    },

    // 跳过任务确认
    skipTask: {
      title: '跳过任务',
      confirm: '确认跳过',
      cancel: '取消',
      message: '跳过任务，将直接将此节点标记为完成，无需后续操作，确认跳过？',
      taskDescription: '跳过任务：{taskName}',
      description: '跳过任务，将直接将此节点标记为完成，无需后续操作。',
      reasonLabel: '跳过原因',
      reasonPlaceholder: '请输入跳过原因',
      reasonRequired: '请输入跳过原因',
      taskInstanceIdNotExists: '任务状态ID不存在',
      success: '任务跳过成功',
      failed: '任务跳过失败',
      notAllowed: '该任务不允许跳过',
      failedWithReason: '跳过任务失败: {reason}'
    },

    // 确认处理任务
    processTask: {
      title: '确认处理任务',
      confirm: '确认处理',
      cancel: '取消',
      question: '确认要处理任务：{taskName} 吗？',
      description: '处理后该任务将标记为完成状态。',
      failed: '处理任务失败',
      failedWithReason: '处理任务失败: {reason}'
    },


    // 加载状态
    loading: {
      failed: '加载订单详情失败',
      notExists: '订单ID不存在'
    },

    // 保存和删除消息
    saveMessages: {
      overviewSuccess: '概览信息保存成功',
      overviewFailed: '概览信息保存失败',
      cargoSuccess: '货物信息保存成功',
      cargoFailed: '货物信息保存失败',
      containerSuccess: '集装箱信息保存成功',
      containerFailed: '集装箱信息保存失败',
      feeSuccess: '费用保存成功',
      feeFailed: '费用保存失败',
      feeDeleteSuccess: '费用删除成功',
      feeDeleteFailed: '费用删除失败',
      orderDetailNotExists: '订单详情不存在，无法新增费用'
    },

    // 任务处理消息
    taskMessages: {
      taskInstanceIdNotExists: '任务实例ID不存在',
      taskInfoNotExists: '任务信息不存在',
      processSuccess: '任务处理成功',
      taskProcessPrefix: '任务处理：'
    },

    // 地图相关
    map: {
      title: '运输路线',
      placeholder: '【脑补下我是世界地图】'
    },

    // 应收费用
    receivableFees: {
      title: '应收费用',
      editModalTitle: '编辑应收费用',
      settlementObject: '结算对象',
      feeName: '费用名称',
      unitPrice: '单价',
      quantity: '数量',
      billingUnit: '计费单位',
      currency: '币种',
      taxRate: '税率',
      taxAmount: '税额',
      inclusiveTaxPrice: '含税价',
      exclusiveTaxPrice: '不含税价',
      invoiceTitle: '开票抬头',
      remarks: '备注',
      createdBy: '创建人',
      createTime: '创建时间',
      modifiedBy: '修改人',
      modifyTime: '修改时间',
      edit: '编辑',
      save: '保存',
      cancel: '取消',
      add: '新增',
      delete: '删除',
      cancelDelete: '取消删除',
      noData: '暂无应收费用数据',
      totalRecords: '共 {count} 条记录',
      willDeleteAfterSave: '保存后此费用将删除',
      placeholders: {
        settlementObject: '请选择结算对象',
        feeName: '请选择或输入费用名称',
        unitPrice: '单价',
        quantity: '数量',
        billingUnit: '请选择计费单位',
        currency: '请选择币种',
        taxRate: '税率',
        taxAmount: '税额',
        inclusiveTaxPrice: '含税价',
        exclusiveTaxPrice: '不含税价',
        invoiceTitle: '开票抬头',
        remarks: '备注'
      }
    },

    // 应付费用
    payableFees: {
      title: '应付费用',
      editModalTitle: '编辑应付费用',
      settlementObject: '结算对象',
      feeName: '费用名称',
      unitPrice: '单价',
      quantity: '数量',
      billingUnit: '计费单位',
      currency: '币种',
      taxRate: '税率',
      taxAmount: '税额',
      inclusiveTaxPrice: '含税价',
      exclusiveTaxPrice: '不含税价',
      invoiceTitle: '开票抬头',
      remarks: '备注',
      createdBy: '创建人',
      createTime: '创建时间',
      modifiedBy: '修改人',
      modifyTime: '修改时间',
      edit: '编辑',
      save: '保存',
      cancel: '取消',
      add: '新增',
      delete: '删除',
      cancelDelete: '取消删除',
      noData: '暂无应付费用数据',
      totalRecords: '共 {count} 条记录',
      willDeleteAfterSave: '保存后此费用将删除',
      placeholders: {
        settlementObject: '请选择结算对象',
        feeName: '请选择或输入费用名称',
        unitPrice: '单价',
        quantity: '数量',
        billingUnit: '请选择计费单位',
        currency: '请选择币种',
        taxRate: '税率',
        taxAmount: '税额',
        inclusiveTaxPrice: '含税价',
        exclusiveTaxPrice: '不含税价',
        invoiceTitle: '开票抬头',
        remarks: '备注'
      }
    }
  },

  // 订单中心操作历史
  operationHistory: {
    emptyValue: '(空)',
    systemOperator: '系统',
    loadFailed: '加载操作历史失败',
    labels: {
      opTime: '操作时间',
      opUser: '操作人',
      opType: '操作类型',
      field: '变更字段名称',
      valueBefore: '变更前值',
      valueAfter: '变更后值',
      opSource: '来源'
    },
    types: {
      create: '创建',
      update: '修改',
      delete: '删除'
    },
    synthetic: {
      created: '已创建',
      existing: '已存在',
      deleted: '已删除'
    },
    components: {
      shipment: '发货申请单',
      transportPlan: '运输计划单',
      transportConsignment: '运输委托单',
      waybill: '运单',
      logistics: '物流信息',
      customs: '报关清关信息',
      contact: '收发通信息',
      packageWd: '件重尺',
      product: '商品信息',
      consignmentInfo: '委托信息',
      consignmentLogistics: '物流信息',
      supplier: '供应商信息',
      container: '柜型信息',
      cargo: '货物信息',
      vehicle: '车辆信息',
      bulkCargo: '散杂货信息',
      consignmentProduct: '商品信息',
      consignmentProductDetail: '商品箱明细',
      voyage: '航程信息',
      packing: '装箱清单',
      trackingNode: '运踪节点'
    }
  },
  distributionShipment: {
    title: '发货申请单',
    placeholder: '发货申请单功能开发中',
    common: {
      yes: '是',
      no: '否',
      none: '暂无',
      actions: '操作',
      back: '返回',
      cancel: '取消',
      cancelShipment: '取消',
      cancelPlan: '取消发货规划',
      freeze: '冻结',
      unfreeze: '解冻',
      edit: '编辑',
      save: '保存',
      print: '打印',
      readOnly: '只读',
      editable: '可编辑',
      partialEditable: '部分可编辑',
      chooseRegion: '选择区域',
      confirmRegion: '确认区域',
      addRow: '新增行',
      new: '新增',
      multiCurrency: '多币种',
      listSeparator: '、'
    },
    create: {
      titlePrefix: '发货申请单：'
    },
    cancelModal: {
      title: '取消发货申请单',
      reasonLabel: '取消原因',
      reasonPlaceholder: '请输入取消原因',
      reasonRequired: '请输入取消原因'
    },
    tabs: {
      basic: '基础信息',
      tracking: '运踪',
      fee: '费用'
    },
    manualPush: {
      button: '手动推送预估费用',
      statusLoading: '正在检查推送状态',
      enabledTip: '仅补推未成功的预估费用账单组',
      disabledTip: '当前不可手动推送预估费用',
      confirmTitle: '确认手动推送',
      confirmContent: '将重新推送当前发货申请单中未成功的预估费用账单组，是否继续？',
      success: '预估费用推送成功，共 {count} 个账单组',
      partialFailed: '预估费用部分推送失败：成功 {successCount} 个，失败 {failedCount} 个',
      partialFailedTitle: '部分账单组推送失败',
      resultCount: '成功 {successCount} 组，失败 {failedCount} 组',
      resultTitle: '预估费用推送结果',
      retryFailed: '重新推送失败账单组',
      retryTip: '再次推送只处理以上失败账单组，已成功账单组不会重复推送。',
      requiredFieldsMissing: 'NS预估账单必填字段缺失',
      billMissingFields: '账单信息：{fields}',
      expenseLineMissingFields: '费用明细第 {index} 条：{fields}',
      fieldLabels: {
        operationType: '操作类型',
        fhNo: 'FH单号',
        subsidiary: '子公司',
        supplierId: '供应商代号',
        currency: '币种',
        journalType: '日记账类型',
        accrualPeriodDate: '预提所属区间日期',
        expenseDetails: '费用明细',
        estimatedAmount: '预估金额',
        businessType: '业务类',
        feeType: '费用类',
        department: '部门',
        costCenter: '成本中心',
        saleStyle: '销售模式',
        bal1: '一级区域',
        bal2: '二级区域',
        bal3: '三级区域',
        brparties: '业务方'
      },
      columns: {
        subsidiary: '子公司',
        currency: '币种',
        supplier: '供应商',
        reason: '失败原因'
      },
      failed: '手动推送预估费用失败'
    },
    sections: {
      basicInfo: '订单基础信息',
      logisticsInfo: '物流信息',
      packageMetrics: '件重尺',
      relatedPlanInfo: '关联计划单信息',
      businessCategory: '业务类',
      businessTags: '业务标签',
      contactAddressInfo: '收发通信息',
      productInfo: '商品信息',
      tracking: '运踪',
      feeDetail: '费用明细',
      operationHistory: '操作历史'
    },
    tags: {
      logisticsEditable: '物流信息可编辑',
      tmsEditable: 'TMS 可编辑'
    },
    empty: {
      tracking: '暂无运踪记录',
      trackingNode: '暂无运踪节点',
      fee: '暂无费用明细',
      operationHistory: '暂无操作历史',
      relatedPlan: '暂无关联计划单',
      contactAddress: '暂无收发通信息'
    },
    trackingTab: {
      planDocType: '运输计划单',
      unplannedPlan: '未关联运输计划',
      currentTrackingNode: '当前运踪节点',
      separator: '：',
      waybillCount: '{count} 个运单',
      noPlan: '暂无运输计划单',
      noWaybill: '暂无关联运单',
      loadFailed: '运踪数据加载失败'
    },
    export: {
      productFilename: '发货申请单商品信息',
      productTitle: '发货申请单商品信息',
      unnamed: '未命名'
    },
    list: {
      filterTitle: '发货申请单筛选',
      create: '新增发货申请单',
      exportTitle: '发货申请单列表',
      total: '共 {count} 条',
      chainHint: '发货规划后进入运输计划、委托单、运单链路'
    },
    outboundNotice: {
      button: '出库通知',
      confirmTitle: '出库通知',
      confirmContent: '确认推送吗?',
      selectRequired: '请选择发货申请单',
      precheckFailedTitle: '出库通知校验未通过',
      precheckFailed: '出库通知校验失败',
      pushFailed: '出库通知推送失败',
      resultTitle: '出库通知推送结果',
      resultSummary: '成功 {successCount} 条，失败 {failureCount} 条',
      notifiedCount: '已通知 +{count}次',
      notNotified: '未通知',
      success: '成功',
      failure: '失败',
      columns: {
        fhNo: '发货申请单号',
        status: '推送结果',
        failureReason: '失败原因'
      }
    },
    plan: {
      title: '发货规划',
      okText: '生成计划单',
      submitApproval: '提交审批',
      cancel: '取消',
      shipmentNo: '发货申请单号',
      destCountry: '目的国',
      expectArrivalDate: '期望送达时间',
      clearanceTradeTerm: '贸易条款（清关）',
      customerConsignment: '是否客户指定',
      expectTransportMode: '期望运输业务类型',
      mainTransportMode: '干线运输业务类型',
      splitStrategy: '拆单方式',
      expressSupplier: '快递承运商',
      expressNo: '上游快递单号',
      splitSegment: '是否纵拆',
      generatedPlanCount: '将生成计划单数',
      countUnit: '条',
      autoCreateContent: '自动创建内容',
      autoCreateTransportPlanConsignment: '运输计划单 + 运输委托单',
      autoCreateTransportPlanConsignmentWaybill: '运输计划单 + 运输委托单 + 运单',
      consignmentStatus: '委托单状态',
      consignmentEntrusted: '已委托',
      consignmentNotEntrusted: '未委托',
      shipWarehouse: '发货仓库',
      consigneeCity: '收货地址/城市',
      selectPlaceholder: '请选择',
      searchSelect: '搜索选择{field}',
      splitYes: '是（三段拆分）',
      splitNo: '否（全程直达）',
      splitDisabledExpress: '快递方式不支持纵拆，全程直达',
      splitDisabledUnsupportedMode: '{mode}不支持纵拆，全程直达',
      splitDisabledCustomerConsignment: '客户指定时不纵拆',
      missingAddressTip: '必须有 1 个发货地址和 1 个收货地址，才能生成运输计划单。',
      fullTip: '当前为全程直达，将生成 1 张计划单：全程（发货仓 → 收货地址）。请确认路线信息后再提交。',
      splitTip: '当前为三段拆分、{endpointMode}，将生成 3 张计划单：港前（发货仓 → 起运地）、干线（起运地 → 目的地）、尾程（目的地 → 收货地址）。请确认路线信息后再提交。',
      twoPreMainTip: '当前为两段拆分（港前+干线）、{endpointMode}，将生成 2 张计划单：港前+干线（发货仓 → 目的地）、尾程（目的地 → 收货地址）。请确认路线信息后再提交。',
      twoMainLastTip: '当前为两段拆分（干线+尾程）、{endpointMode}，将生成 2 张计划单：港前（发货仓 → 起运地）、干线+尾程（起运地 → 收货地址）。请确认路线信息后再提交。',
      splitStrategyOptions: {
        full: '全程直达',
        three: '三段拆分',
        twoPreMain: '两段：港前+干线{\'|\'}尾程',
        twoMainLast: '两段：港前{\'|\'}干线+尾程'
      },
      expressCompleteTip: '将自动创建对应计划单、委托单和运单。',
      expressMissingNoTip: '万里牛暂无快递单号，运单未创建，请补录后手动添加运单。',
      expressMissingSupplierTip: '快递承运商为空，委托单状态为未委托，请补录承运商后创建委托单。',
      expressMissingBothTip: '快递承运商和快递单号均为空，请补录后手动完成委托和运单创建。',
      portPrefix: {
        loading: '起运',
        discharge: '目的'
      },
      endpointType: {
        country: '国',
        port: '港'
      },
      endpointMode: {
        country: '国家模式',
        port: '港口模式',
        mixed: '国/港混合模式'
      },
      portType: {
        airport: '机场',
        landPort: '口岸',
        railwayStation: '铁路站点',
        seaport: '港'
      }
    },
    subtable: {
      empty: '暂无运输计划单',
      planDetailTodo: '计划单详情后续单独处理',
      planDetailTodoWithNo: '计划单详情后续接入：{no}',
      columns: {
        planNo: '计划单号',
        segment: '运输段落',
        mainTransportMode: '本程运输业务类型',
        originPoint: '本段起运地',
        destPoint: '本段目的地',
        mainlineOriginCountry: '起运国',
        mainlineDestCountry: '目的国',
        portOfLoading: '起运港',
        portOfDischarge: '目的港',
        planStatus: '计划单状态',
        trackingStatus: '运踪状态'
      },
      segment: {
        preCarriage: '港前',
        mainCarriage: '干线',
        lastMile: '尾程',
        fullCarriage: '全程'
      },
      planStatus: {
        inTransit: '运输中'
      }
    },
    packageMetrics: {
      source: '数据来源',
      totalQty: '总个数',
      totalBoxQty: '箱数',
      totalPalletQty: '托盘数',
      totalVolume: '总体积',
      totalWeight: '总重量',
      chargeWeight: '计费重',
      length: '长',
      width: '宽',
      height: '高',
      expectSource: '理论值',
      warehouseSource: '仓库数据',
      supplierSource: '货代数据'
    },
    table: {
      requiredTitle: '{field} *'
    },
    contactAddress: {
      warehouseLoadFailed: '仓库地址查询失败，原地址已清空，请重新选择仓库或手工填写',
      warehouseEnglishMissing: '所选仓库未维护英文版本，对应地址已清空，请手工填写',
      warehouseCountryMissing: '未找到所选仓库对应的租户国家或所需语种名称，请手工选择国家',
      importExcel: '导入 Excel',
      importDisabledTip: '仅国内快递场景支持批量导入',
      aiRecognize: 'AI 识别',
      aiTitle: 'AI 地址识别',
      aiTip: '请输入完整地址，系统将自动解析为结构化字段；支持多条地址同时识别',
      aiPlaceholder: '粘贴原始地址文本，每行一条地址。例如：\n中国广东省深圳市南山区科技园南区A座8楼 张伟 13800138000',
      aiTargetLabel: '识别结果将填充到表格中：',
      cancel: '取消',
      startRecognition: '开始识别',
      aiEmptyInput: '请输入原始地址文本',
      importInvalidType: '仅支持 xls、xlsx 格式文件',
      importNoFile: '请选择导入文件',
      importFailed: '收发通地址导入失败',
      importPartialError: '导入文件存在 {count} 条错误：{detail}',
      applySuccess: '已填充 {count} 条收发通地址，请在表格中核对',
      applySkipped: '{count} 条地址因类型达到上限未写入',
      aiFailed: '{count} 条地址识别失败，请检查后重试',
      countryUnmatched: '以下国家未匹配到基础数据，请手工选择：{countries}',
      noRowsApplied: '没有可写入的收发通地址',
      importErrors: {
        emptyFile: 'Excel 文件为空',
        missingHeaders: '缺少必填表头：{headers}',
        illegalType: '地址类型不合法，仅支持发货地址、收货地址、通知地址、报关发货地址、报关收货地址、清关发货地址、清关收货地址、实际提货地、实际送达地',
        noData: 'Excel 文件没有可导入的数据',
        unknown: '导入行解析失败'
      },
      partyType: {
        shipper: '发货地址',
        consignee: '收货地址',
        notify: '通知地址',
        customsShipper: '报关发货地址',
        customsConsignee: '报关收货地址',
        clearanceShipper: '清关发货地址',
        clearanceConsignee: '清关收货地址',
        actualPickup: '实际提货地',
        actualDelivery: '实际送达地'
      }
    },
    messages: {
      queryFailed: '发货申请单查询失败',
      emptyShipmentData: '发货申请单数据为空',
      emptyDetailId: '发货申请单ID为空，无法查看详情',
      emptyPlanId: '发货申请单ID为空，无法发货规划',
      detailLoadFailed: '发货申请单详情加载失败',
      operationHistoryLoadFailed: '操作历史加载失败',
      enteredPlanApproval: '已进入发货规划审批状态',
      transportPlanGenerated: '运输计划单已生成',
      planFailed: '发货规划失败',
      emptyEditId: '发货申请单ID为空，无法编辑',
      copyOfflineOnly: '仅线下单支持复制',
      emptyCopyId: '发货申请单ID为空，无法复制',
      noExportData: '暂无可导出的发货申请单数据',
      noProductExportData: '暂无可导出的商品信息',
      csvExportSuccess: 'CSV 导出成功',
      excelExportSuccess: 'Excel 导出成功',
      planAlreadyGenerated: '已生成运输计划单，如需重新生成请先取消发货规划',
      planApprovalPending: '发货规划审批中',
      planStatusDisabled: '当前状态不可发货规划',
      cancelSourceUnsupported: '当前来源的发货申请单不可取消',
      cancelActivePlanExists: '请先取消或删除全部关联运输计划后再取消发货申请单',
      cancelStatusDisabled: '当前状态不可取消',
      cancelPlanStatusDisabled: '仅正操作或 OMS 推送阻断冻结且已拆单状态可取消发货规划',
      cancelShipmentConfirmTitle: '确认取消',
      cancelShipmentConfirmContent: '取消后发货申请单将变为已取消，是否继续？',
      cancelShipmentSuccess: '发货申请单已取消',
      cancelShipmentFailed: '取消发货申请单失败',
      cancelFailureTitle: '取消失败',
      wmsOrderNotFound: 'WMS 中不存在该单号',
      cancelFailureGuidance: 'TMS无法取消该单，请线下协调处理后重新申请取消。',
      cancelRequestFailed: '取消请求失败或响应超时，请线下核实处理结果。',
      tmsOnlyCancelConfirmContent: 'WMS 中不存在该单号。可选择仅在 TMS 侧取消发货申请单（不同步 WMS）。',
      tmsOnlyCancelOkText: '仅TMS取消',
      tmsOnlyCancelFailed: '仅取消 TMS 发货申请单失败',
      cancelPlanConfirmTitle: '确认取消发货规划',
      cancelPlanConfirmContent: '取消后下属运输计划将取消，发货申请单可重新发货规划，是否继续？',
      cancelPlanSuccess: '发货规划已取消',
      cancelPlanFailed: '取消发货规划失败',
      freezeConfirmTitle: '确认冻结',
      freezeConfirmContent: '冻结后发货申请单将暂停下游操作，是否继续？',
      freezeSuccess: '发货申请单已冻结',
      freezeFailed: '冻结发货申请单失败',
      unfreezeConfirmTitle: '确认解冻',
      unfreezeConfirmContent: '解冻后发货申请单将恢复正操作，是否继续？',
      unfreezeSuccess: '发货申请单已解冻',
      unfreezeFailed: '解冻发货申请单失败',
      emptyLoadDetailId: '发货申请单ID为空，无法加载详情',
      readonlyByStatus: '当前发货申请单状态不可编辑，已按只读模式展示',
      copySuccessWithNo: '已复制发货申请单 {no}，请确认后保存',
      copySuccess: '已复制发货申请单，请确认后保存',
      externalEditScopeHint: '目的仓库、目的仓库编码、期望发货时间、货好时间、期望到货时间、物流信息、业务标签、收发通信息可编辑，其余只读',
      calculatedByProducts: '按商品计算 {amount}',
      theoreticalChargeWeightSkippedProducts: 'SKU {skuCodes} 存在缺失包装数据，缺失部分未参与理论件重尺计算',
      theoreticalChargeWeightCalculationFailed: '理论件重尺自动计算失败，可手工填写',
      businessDataLoadFailed: '{types}加载失败，可手工输入，请稍后重试',
      businessDataNotConfigured: '{types}暂无平台配置，可手工输入',
      transportPlanUpdated: '运输计划已更新',
      saveSuccess: '保存成功'
    },
    businessDataTypes: {
      businessClass: '业务类',
      costCenter: '成本中心',
      salesMode: '销售模式',
      businessDepartment: '业务部门',
      region: '区域',
      separator: '、'
    },
    placeholders: {
      input: '请输入{field}',
      batchInput: '请输入{field}，多个用逗号/空格分隔',
      select: '请选择{field}',
      startDate: '开始日期',
      endDate: '结束日期',
      startTime: '开始时间',
      endTime: '结束时间',
      selectOrderTypeFirst: '请先选择订单类型',
      searchCustomerName: '搜索客户简称/名称',
      searchCustomerShortName: '搜索客户简称',
      customerAutoFill: '选择客户后带出',
      searchCustomerCode: '搜索客户编码/名称',
      systemAutoFill: '系统回填',
      destCountryAutoFill: '根据收货地址国家带出',
      tradeChain: '公司简称1 -> 公司简称2 -> 公司简称3',
      selectOnly: '请选择',
      selectOrInputCurrency: '请选择或输入币种',
      selectOrInputTotalAmount: '请选择或输入总金额',
      selectOrInputTotalTax: '请选择或输入总税额',
      selectOrInputClearanceAmount: '请选择或输入清关货值',
      regionCodePath: '请输入三级区域编码，使用 / 分隔',
      regionPath: '请输入三级区域，使用 / 分隔',
      inputTag: '输入后按 Enter 添加',
      selectOrInputProvince: '请选择或输入省州',
      selectOrInputDistrict: '请选择或输入区县'
    },
    validation: {
      requiredSelect: '请选择{field}',
      requiredInput: '请输入{field}',
      regionPathsRequiredTogether: '区域编码和区域必须同时填写',
      regionPathInvalid: '区域编码和区域都必须严格填写三级，并使用 / 分隔',
      regionPickerIncomplete: '请选择完整的一级、二级、三级区域',
      contactShipperRequired: '收发通信息至少需要 1 条发货地址',
      contactConsigneeRequired: '收发通信息至少需要 1 条收货地址',
      contactRowIncomplete: '请补全收发通信息第 {row} 行：{fields}',
      productRowIncomplete: '请补全商品信息第 {row} 行：{fields}'
    },
    options: {
      source: {
        wln: '万里牛',
        offline: '线下'
      },
      mainStatus: {
        created: '已创建',
        approving: '审批中',
        approved: '已审核',
        inOperation: '正操作',
        completed: '已完成',
        frozen: '已冻结',
        cancelled: '已取消'
      },
      splitStatus: {
        notSplit: '未拆单',
        split: '已拆单'
      },
      transportMode: {
        seaFcl: '海运整箱',
        seaLcl: '海运拼箱',
        air: '空运',
        land: '陆运',
        rail: '铁路',
        express: '快递',
        other: '其他'
      },
      logisticsDirection: {
        forward: '正向',
        reverse: '逆向'
      },
      customsType: {
        none: '不报关',
        formal: '正式报关',
        expressClearance: '快速清关'
      },
      orderType: {
        sales: '销售订单',
        nonSales: '非销售订单'
      },
      docSubtype: {
        directSales: '直销',
        distribution: '分销',
        transfer: '调拨',
        sample: '寄样',
        returned: '退货'
      },
      bizDept: {
        northAmerica: '北美',
        international: '国际',
        domestic: '国内'
      },
      goodsType: {
        standardProduct: '标准产品',
        marketingMaterial: '营销物料',
        rawMaterial: '原材料',
        gift: '赠品'
      },
      salesPlatform: {
        offline: '线下',
        other: '其他'
      },
      partyType: {
        shipper: '发货方',
        consignee: '收货方',
        notify: '通知方',
        customsShipper: '报关发货地址',
        customsConsignee: '报关收货地址',
        clearanceShipper: '清关发货地址',
        clearanceConsignee: '清关收货地址',
        actualPickup: '实际提货地',
        actualDelivery: '实际送达地'
      },
      operationType: {
        create: '新增',
        update: '修改',
        delete: '删除'
      }
    },
    fields: {
      fhNo: '单号',
      businessCategory: '业务类',
      fhCateg: '业务类编码',
      fhCategName: '业务类名称',
      orderNo: '订单编号',
      orderStatus: '订单状态',
      mainStatus: '主状态',
      splitStatus: '拆单状态',
      currentTrackingNode: '当前运踪节点',
      source: '来源',
      orderType: '订单类型',
      docSubtype: '单据小类',
      goodsType: '货品信息',
      bizTags: '业务标签',
      customer: '客户',
      customerNo: '客户编号',
      customerShortName: '客户简称',
      customerCode: '客户编码',
      cusShortName: '客户简称',
      cusName: '客户名称',
      cusNo: '客户编码',
      regionCodePath: '区域编码',
      regionPath: '区域',
      regionLevelOne: '一级区域',
      regionName: '一级区域名称',
      regionLevelTwo: '二级区域',
      regionLevel2Name: '二级区域名称',
      regionLevelThree: '三级区域',
      regionLevel3Name: '三级区域名称',
      costCenter: '成本中心编码',
      costCenterName: '成本中心',
      bizDept: '业务部门编码',
      departmentName: '业务部门',
      salesType: '销售模式编码',
      salesTypeName: '销售模式名称',
      salesPlatform: '销售平台',
      originWhCode: '发货仓库编码',
      originWh: '发货仓库',
      destinationWhCode: '目的仓库编码',
      destinationWh: '目的仓库',
      expectShipDate: '期望发货日期',
      goodsReadyTime: '货好时间',
      outboundNoticeSuccessCount: '出库通知状态',
      actShipDate: '实际发货时间',
      expectArrivalDate: '期望到货日期',
      actArrivalDate: '实际到货时间',
      originCreateTime: '来源创建时间',
      originCreator: '来源系统创建人',
      consignmentOrder: '委托单',
      orderReferenceRemark: '单号备注（PO/FBA/SW）',
      orderRemark: '订单备注',
      cancelReason: '取消原因',
      logisticsOperator: '物流操作员',
      logisticsOperatorText: '来源系统物流专员',
      createdAt: '业务创建时间',
      updatedAt: '业务更新时间',
      systemCreatedAt: '系统创建时间',
      systemUpdatedAt: '系统更新时间',
      insure: '是否购买保险',
      pickingTime: '拣货时间',
      pickingUser: '拣货人',
      pickingRemark: '拣货备注',
      crossBorder: '是否跨境',
      palletized: '是否打托',
      logisticsDirection: '物流流向',
      expectTransportMode: '期望运输业务类型',
      mainTransportMode: '干线运输业务类型',
      splitSegment: '是否纵拆',
      splitStrategy: '拆分策略',
      customerConsignment: '是否客户指定',
      tradeCountry: '贸易国',
      tradeCountryEn: '贸易国（英）',
      destCountry: '运抵国',
      destCountryEn: '运抵国（英）',
      tradeChain: '贸易链路',
      customsTradeTerm: '贸易条款（报关）',
      clearanceTradeTerm: '贸易条款（清关）',
      transportTerms: '运输条款',
      expressSupplier: '快递承运商',
      expressNo: '上游快递单号',
      customsFlag: '是否报关',
      customsType: '报关类型',
      currency: '币种',
      taxCurrency: '总税额币种',
      totalAmount: '总金额',
      totalTax: '总税额',
      clearanceTotalAmountCurrency: '清关总金额币种',
      clearanceTotalAmount: '清关货值',
      exchangeRate: '汇率',
      hsCode: 'HS编码',
      originCountry: '原产国',
      bizRemark: '运输备注',
      region: '区域',
      totalAmountCurrency: '总金额币种',
      totalTaxCurrency: '总税额币种',
      partyType: '类型',
      company: '公司',
      contactName: '联系人',
      phone: '联系电话',
      country: '国家',
      province: '省州',
      city: '城市',
      district: '区县',
      town: '街道',
      address: '详细地址',
      postcode: '邮编',
      skuCode: 'SKU',
      productName: '产品名称',
      salesOrderNo: '上游订单号',
      docType: '单据类型',
      productModel: '产品型号',
      brand: '品牌',
      specialAttributes: '货品特殊属性',
      barCode: 'UPC条码',
      pcsQty: '个数',
      boxGauge: '外箱规格',
      stdBoxQty: '标箱数量',
      actualBoxQty: '实际箱数',
      packingMethod: '包装方式',
      cisOsNo: 'CIS OS号',
      cnDesc: '中文描述',
      enDesc: '英文描述',
      customsDecl: '海关申报要素',
      amountOrigin: '原金额',
      unitPriceOrigin: '原单价',
      unitPrice: '含税单价',
      unitPriceNet: '不含税单价',
      amtNet: '未税金额',
      amtFh: '含税金额',
      tax: '税额',
      taxRatio: '税率',
      unitPriceAg: '清关不含税单价',
      amountNetAg: '清关不含税金额',
      amountTaxAg: '清关税额',
      amountAllAg: '清关含税金额',
      currencyAg: '清关货币',
      unitPriceBg: '报关不含税单价',
      amountNetBg: '报关不含税金额',
      amountTaxBg: '报关税额',
      amountAllBg: '报关含税金额',
      currencyBg: '报关货币',
      infoType: '信息类型',
      buyerNameCn: '买家名称中文',
      buyerNameEn: '买家名称英文',
      buyerLocationCn: '买家地址中文',
      buyerLocationEn: '买家地址英文',
      buyerTelephone: '买家电话',
      buyerFax: '买家传真',
      sellerNameCn: '卖家名称中文',
      sellerNameEn: '卖家名称英文',
      sellerLocationCn: '卖家地址中文',
      sellerLocationEn: '卖家地址英文',
      importer: '进口方',
      declarationAgentNameEn: '报关家名称英文',
      taxNo: '税号',
      einNo: 'EIN号',
      taxAddress: '税号地址',
      sellerTelephone: '卖家电话',
      sellerFax: '卖家传真',
      sellerPost: '进口方邮编',
      sellerWebsite: '进口方网址',
      subsidiary: '子公司',
      locationCountry: '所在国',
      addressId: '地址ID',
      innerPo: 'Inner PO',
      popInvoiceType: '营销物料清关模板类型',
      popMemo: '清关发票备注',
      volumeUnit: '体积单位',
      weightUnit: '重量单位',
      lengthUnit: '长度单位',
      weightCount: '计费重单位',
      totalQtyExpect: '理论总个数',
      totalBoxQtyExpect: '理论总箱数',
      totalPalletQtyExpect: '理论总托数',
      totalVolumeExpect: '理论总体积',
      totalWeightExpect: '理论总重量',
      totalWeightCountExpect: '理论计费重',
      lengthExpect: '理论长度',
      widthExpect: '理论宽度',
      heightExpect: '理论高度',
      totalQtyWh: '仓库总个数',
      totalBoxQtyWh: '仓库总箱数',
      totalPalletQtyWh: '仓库总托数',
      wmsPickingTotalPackages: 'WMS备货包裹数',
      wmsOutboundTotalPackages: 'WMS出库包裹数',
      wmsPalletTotalPackages: 'WMS栈板包裹数',
      totalVolumeWh: '仓库总体积',
      totalWeightWh: '仓库总重量',
      totalWeightCountWh: '仓库计费重',
      lengthWh: '仓库长度',
      widthWh: '仓库宽度',
      heightWh: '仓库高度',
      totalQtySupplier: '供应商总个数',
      totalBoxQtySupplier: '供应商总箱数',
      totalPalletQtySupplier: '供应商总托数',
      totalVolumeSupplier: '供应商总体积',
      totalWeightSupplier: '供应商总重量',
      totalWeightCountSupplier: '供应商计费重',
      lengthSupplier: '供应商长度',
      widthSupplier: '供应商宽度',
      heightSupplier: '供应商高度',
      productTotalQuantity: '总个数',
      productAmount: '商品金额',
      customsTotalAmount: '报关货值',
      transportSegment: '运输段落',
      logSeq: '序号',
      opTime: '操作时间',
      opUser: '操作人',
      opSource: '来源',
      opType: '操作类型',
      field: '变更字段',
      valueBefore: '变更前值',
      valueAfter: '变更后值',
      actions: '操作'
    }
  },

  // 运踪查询
  trackingQuery: {
    title: '运踪查询',
    queryTypePlaceholder: '请选择查询类型',
    queryTypeDocument: 'HBL NO./ MBL NO./业务参考号/Cargoware业务号',
    queryTypeContainer: '箱号',
    inputPlaceholder: '多个单号用逗号、空格或换行分隔',
    search: '查询',
    detail: '详情',
    emptyTip: '请输入单号后点击查询',
    limitTip: '最多支持 20 个单号，已自动截取',
    notFound: '未查询到匹配订单',
    unmatchedTip: '以下单号未匹配：{numbers}',
    matched: '订单号：{orderNo}',
    matchedCount: '共匹配到 {count} 票订单'
  },

  // 车架号查询
  chassisQuery: {
    title: '车架号查询',

    // 筛选字段
    filters: {
      jobNo: '提单号',
      jobNoPlaceholder: '请输入提单号(MB/L NO+S/O NO)',
      chassisNo: '车架号',
      chassisNoPlaceholder: '请输入车架号',
      vessel: '船名',
      vesselPlaceholder: '请输入船名',
      voyage: '航次',
      voyagePlaceholder: '请输入航次',
      pol: '起运港',
      polPlaceholder: '请选择起运港',
      pod: '目的港',
      podPlaceholder: '请选择目的港',
      sailingDate: '开航日期',
      sailingDatePlaceholder: '请选择日期范围',
      abnormalStatus: '异常情况',
      abnormalStatusPlaceholder: '请选择异常情况',
      all: '全部',
      has: '有',
      none: '无'
    },

    // 表格列
    columns: {
      jobNo: '提单号',
      chassisNo: '车架号',
      vehicleNo: '车辆号',
      pol: '起运港',
      pod: '目的港',
      vesselVoyage: '船名/航次',
      receivedDate: '收货日期',
      preLoadSurveyDate: '装船前检验日期',
      manual: '说明书',
      spareTire: '备胎',
      key: '钥匙/数量',
      abnormalStatus: '异常情况',
      actions: '操作',
      view: '查看'
    },

    // 详情抽屉
    detail: {
      drawerTitle: '车架号详情',

      // 出运数据
      shippingData: {
        title: '出运数据',
        pol: '起运港',
        pod: '目的港',
        vesselVoyage: '船名/航次',
        receivedDate: '收货日期',
        preLoadSurveyDate: '装船前检验日期'
      },

      // 车辆信息
      vehicleInfo: {
        title: '车辆信息',
        jobNo: '提单号',
        chassisNo: '车架号',
        vehicleNo: '车辆号',
        manual: '说明书',
        spareTire: '备胎',
        keyQuantity: '钥匙/数量',
        abnormalDescription: '异常情况说明',
        adjustDescription: '调整情况说明',
        abnormalPhotos: '异常情况照片'
      },

      // 基础信息 (保留原有的以防其他地方使用)
      basicInfo: {
        title: '基础信息',
        jobNo: '提单号',
        chassisNo: '车架号',
        vehicleNo: '车辆号',
        brandModel: '品牌型号',
        yearOfManufacture: '生产年份',
        color: '颜色',
        mileage: '里程',
        engineNo: '发动机号'
      },

      // 港口及船期信息
      portSchedule: {
        title: '港口及船期信息',
        pol: '起运港',
        pod: '目的港',
        vessel: '船名',
        voyage: '航次',
        eta: '预计到港时间',
        etd: '预计开航时间',
        ata: '实际到港时间',
        atd: '实际开航时间'
      },

      // 收货检验信息
      inspection: {
        title: '收货检验信息',
        receivedDate: '收货日期',
        preLoadSurveyDate: '装船前检验日期',
        fuelLevel: '燃油量',
        inspector: '检验员',
        inspectionLocation: '检验地点'
      },

      // 随车物品
      accessories: {
        title: '随车物品',
        manual: '说明书',
        spareTire: '备胎',
        key: '钥匙',
        keyQuantity: '钥匙数量',
        toolKit: '工具包',
        firstAidKit: '急救箱',
        fireExtinguisher: '灭火器',
        warningTriangle: '警示三角牌',
        others: '其他'
      },

      // 异常及调整情况
      abnormal: {
        title: '异常及调整情况',
        hasAbnormal: '是否有异常',
        abnormalDescription: '异常描述',
        damageLevel: '损坏程度',
        repairRequired: '是否需要维修',
        repairCost: '维修费用',
        responsibleParty: '责任方',
        remarks: '备注'
      },

      // 异常情况照片
      photos: {
        title: '异常情况照片',
        noPhotos: '暂无照片',
        uploadDate: '上传时间',
        photoDescription: '照片说明'
      },

      // 状态值
      yes: '有',
      no: '无',
      normal: '正常',
      abnormalStatus: '异常'
    },

    // 消息
    messages: {
      querySuccess: '查询成功',
      queryFailed: '查询失败',
      loadDetailFailed: '加载详情失败'
    },

    // 空状态
    empty: {
      description: '请输入筛选条件，点击【查询】'
    }
  },

  // 订单管理页面
  management: {
    // 筛选
    filterTitle: '订单筛选',

    // Tab 标签
    tabs: {
      sea: '海运订单',
      air: '空运订单',
      land: '陆运订单',
      rail: '铁路订单'
    },

    // 表格列
    columns: {
      orderNo: '订单编号',
      orderType: '订单类型',
      pol: '起运港',
      pod: '目的港',
      carrier: '船公司',
      vesselName: '船名航次',
      createdBy: '创建人',
      dateCreated: '创建时间',
      syncStatus: '订单同步状态',
      cargoJobNo: 'Cargo业务编号',
      customReferenceNo: '业务参考号',
      mblNo: 'MBL单号',
      hblNo: 'HBL单号',
      containerNos: '箱号',
      actions: '操作'
    },

    // 弹窗
    modal: {
      createOrder: {
        title: '新增订单',
        cancel: '取消',
        confirm: '确认'
      },
      syncOrder: {
        title: '同步订单',
        selectPlatform: '选择第三方平台',
        selectPlatformPlaceholder: '请选择第三方平台',
        selectPlatformRequired: '选择第三方平台',
        selectModes: '选择同步模式',
        selectModesRequired: '选择同步模式',
        syncNewOrders: '同步新增订单',
        updateExistingOrders: '更新已有订单',
        confirmSync: '确认同步',
        close: '关闭',
        successTitle: '🎉 同步成功！',
        newOrders: '新增订单：',
        updateOrders: '更新订单：',
        tickets: '票'
      }
    },

    // 展开/收起
    expand: {
      expandAll: '展开',
      collapseAll: '收起',
      expandAllTitle: '展开全部',
      collapseAllTitle: '收起全部'
    },

    // 导出
    export: {
      filename: '订单数据',
      title: '订单管理表格',
      contextMenuExportHint: '右键点击表格区域，可导出 Excel / CSV 文件',
      noSelectedData: '没有选中的数据',
      taskFailed: '导出任务提交失败，请稍后重试！'
    }
  },

  // 订舱页面
  booking: {
    // 页面标题
    title: '海运整箱订舱',
    pageTitle: {
      newBooking: '新建订舱申请',
      newOrder: '新建订单',
      priceNo: '运价号：{priceNo}'
    },

    specialPrice: {
      title: '特价订单',
      applicationNo: '特价申请单号',
      rateType: '运价类型',
      expireAt: '特价有效期至',
      fcl: '整箱',
      lcl: '拼箱',
      prePort: '港前',
      lastMile: '尾程',
      lclQuantityTitle: '特价计费数量',
      loadFailed: '特价申请加载失败',
      loadFailedDescription: '无法获取特价申请下单数据，请稍后重试',
      retry: '重试',
      back: '返回',
      fclQuantityRequired: '请至少选择一个已审批箱型',
      lclQuantityRequired: '特价计费数量必须大于 0',
      columns: {
        feeName: '费用名称',
        billingUnit: '计费单位',
        approvedUnitPrice: '审批单价',
        quantity: '数量',
        subtotal: '小计'
      }
    },

    // 按钮
    buttons: {
      saveDraft: '暂存',
      bookNow: '立即订舱',
      confirm: '确认',
      cancel: '取消'
    },

    // 标签
    tags: {
      viewMode: '查看模式'
    },

    // 组件标题
    componentTitles: {
      selectContainer: '选择箱型箱量',
      uploadBookingDoc: '上传托书 *',
      uploadOtherFiles: '上传其他文件',
      rateDetail: '费用明细'
    },

    // 航线信息区域(RouteInfo)
    routeInfo: {
      contractPrice: '合约价',
      spotPrice: 'SPOT价',
      transit: '中转',
      direct: '直达',
      transitPort: '中转港',
      allTransitPorts: '所有中转港口：',
      voyageDays: '航程 • {days}天',
      validPeriod: '有效期: {from} ~ {to}',
      totalEstimatedCost: '预估费用总计',
      convertedAmount: '折合¥ {amount}',
      seaFreightAndSurcharge: '其中海运费 {seaFreight}{surcharge}',
      freightAndSurcharge: '其中{freight} {freightAmount}{surcharge}',
      surchargeLabel: ' 附加费 {surcharge}',
      viewDetail: '查看明细',
      exchangeRateTip: '1美元 = 7.1419人民币 (2025-07-28 09:26:03更新) ——汇率仅供参考，请以银行实际结算汇率为准。海运整箱的报价，运价、附加费、增值服务根据委托的实际情况可能会有所调整，以最终确认的为准。',
      laneCode: '航线代码',
      detentionFreeDays: '免用箱',
      demurrageFreeDays: '免堆存',
      spaceStatus: '舱位状态',
      overweightRemarks: '超重说明',
      priceNotes: '运价备注',
      expand: '展开',
      collapse: '收起',
      loading: '加载中...',
      daysUnit: '天'
    },

    // 船期选择
    schedule: {
      title: '船期信息',
      selectSchedule: '选择船期',
      changeSchedule: '更换船期',
      notSelectedTip: '尚未选择船期，请点击选择',
      vesselVoyage: '船名/航次',
      etd: 'ETD (开航)',
      eta: 'ETA (到港)',
      customsCutoff: '截关时间',
      portCutoff: '截港时间',
      declarationDeadline: '报关截止',
      scheduleRequired: '请先选择船期',
      modalTitle: '选择船期',
      emptyText: '暂无匹配船期',
      selectAction: '选择',
      moreSchedules: '更多船期',
      confirmSelect: '已成功选择船期'
    },

    // 费用明细抽屉
    rateDetail: {
      containerMode: '按箱型计费',
      nonContainerMode: '非按箱型计费',
      seaFreight: '海运费',
      prePortFreight: '港前运费',
      lastMileFreight: '尾程运费',
      surcharge: '附加费',
      columns: {
        feeName: '费用名称',
        currency: '币种',
        measure: '计费单位',
        price: '价格',
        quantity: '数量',
        subtotal: '小计',
        note: '备注'
      }
    },

    // 提示信息
    tips: {
      uploadBookingDocTip: '上传托书将自动调用AI识别，快速帮您录入订舱信息'
    },

    // 弹窗
    modal: {
      confirmTitle: '确认提交',
      confirmMessage: '确认提交订舱信息？',
      confirmButton: '确认',
      cancelButton: '取消'
    },

    // 表单验证消息
    validation: {
      placeOfDeliveryRequired: '收货地是必填项',
      polRequired: '起运港是必填项',
      portOfDischargeRequired: '卸货港是必填项',
      podRequired: '目的港是必填项',
      piecesRequired: '件数是必填项',
      weightRequired: '毛重是必填项',
      cubageRequired: '体积是必填项',
      packagesRequired: '包装类型是必填项',
      termsTypeRequired: '条款类型是必填项',
      releaseTypeRequired: '放货方式是必填项',
      englishGoodsDescriptionRequired: '英文品名是必填项',
      shipperNameRequired: '发货人名称是必填项',
      shipperAddressRequired: '发货人地址是必填项',
      consigneeNameRequired: '收货人名称是必填项',
      consigneeAddressRequired: '收货人地址是必填项',
      cargoReadyTimeRangeRequired: '请选择货好时间区间',
      cargoReadyTimeDateRequired: '请选择货好具体日期'
    },

    // 消息提示
    messages: {
      recognizing: '正在识别托书内容...',
      recognitionSuccess: '托书识别完成',
      recognitionFailed: '托书识别失败，请手动填写表单',
      pleaseCompleteRequiredFields: '请完善必填信息',
      bookingSuccess: '订舱申请提交成功',
      bookingFailed: '订舱申请失败',
      saveDraftSuccess: '暂存成功',
      cannotSaveDraft: '无法暂存：未找到任务信息',
      saveDraftRemarks: '暂存订舱数据',
      bookingTaskCompleted: '订舱任务完成',
      bookingSubmitted: '订舱申请已提交',
      getPriceDetailFailed: '获取运价详情失败',
      getQuotationDetailFailed: '获取报价详情失败',
      getInquiryDetailFailed: '获取询价详情失败',
      getTaskDataFailed: '获取任务数据失败'
    },

    // 货物信息组件
    cargoInfo: {
      warning: '以下信息需要填写准确信息，请仔细填写。如有变更请及时联系客服备案',
      labels: {
        placeOfDelivery: '收货地',
        pol: '起运港',
        portOfDischarge: '卸货港',
        pod: '目的港',
        vessel: '船名',
        voyage: '航次',
        pieces: 'No.of(件数)',
        weight: 'Gross Weight (毛重)',
        cubage: 'Measurement (体积)',
        packages: 'Packages (包装)',
        termsType: '条款类型',
        cargoReadyTime: '货好时间',
        releaseType: 'Type of Release(放货方式)',
        englishGoodsDescription: 'English Description of Goods (英文品名)',
        marksAndNumbers: 'Marks & Numbers (唛头标识)',
        carrier: '船公司',
        cargoType: '货物类型',
        transportTerms: '运输条款',
        freightTerm: '运费条款'
      },
      tips: {
        generalOnly: '暂时仅支持普货订舱'
      },
      placeholders: {
        placeOfDelivery: '请选择收货地',
        pol: '请选择起运港',
        portOfDischarge: '请选择卸货港',
        pod: '请选择目的港',
        vessel: '请输入船名（非必填）',
        voyage: '请输入航次（非必填）',
        pieces: '请输入',
        weight: '请输入',
        cubage: '请输入',
        packages: '请选择包装类型',
        termsType: '请选择贸易条款',
        releaseType: '请选择',
        englishGoodsDescription: '请输入',
        marksAndNumbers: '请输入',
        carrier: '请选择船公司',
        cargoType: '请选择货物类型',
        transportTerms: '请选择运输条款',
        freightTerm: '请选择运费条款',
        cargoReadyTimeRange: '请选择',
        cargoReadyTimeDate: '请选择具体日期'
      },
      cargoReadyTime: {
        range: '区间',
        date: '日期',
        withinWeek: '一周内',
        options: {
          threeDays: '三天内',
          oneWeek: '一周内',
          twoWeeks: '二周内',
          oneMonth: '一个月内',
          moreThanMonth: '一月以上',
          unknown: '时间未知'
        }
      },
      units: {
        weight: 'KG',
        volume: 'm³'
      }
    },

    // 联系人信息组件
    contactInfo: {
      title: '联系人信息',
      labels: {
        shipperName: 'Shipper(发货人名称)',
        shipperAddress: 'Shipper\'s Address(发货人地址)',
        consigneeName: 'Consignee(收货人名称)',
        consigneeAddress: 'Consignee\'s Address(收货人地址)',
        notifierName: 'Notifier(通知人名称)',
        notifierAddress: 'Notify\'s Address(通知人地址)',
        contractingParty: '签约方',
        carrierContactPlace: '船公司联络地',
        blIssuePlace: '提单签发地',
        forwarderName: '货运代理企业名称',
        shipperContact: '发货人联系人',
        landline: '座机电话'
      },
      placeholders: {
        shipperName: '请输入发货人名称',
        shipperAddress: '请输入发货人地址',
        consigneeName: '请输入收货人名称',
        consigneeAddress: '请输入收货人地址',
        notifierName: '请输入通知人名称',
        notifierAddress: '请输入通知人地址',
        contractingParty: '请输入签约方',
        carrierContactPlace: '请选择船公司联络地',
        blIssuePlace: '请选择提单签发地',
        forwarderName: '请输入货运代理企业名称',
        shipperContact: '请输入发货人联系人',
        countryCode: '国家代码',
        areaCode: '区号',
        phoneNumber: '座机号码'
      },
      checkboxes: {
        toOrder: 'TO ORDER',
        sameAsConsignee: 'SAME AS CONSIGNEE'
      }
    },

    // 箱型选择组件
    containerSelection: {
      cargoType: '货物类型',
      vesselVoyage: '船名航次',
      change: '更换',
      unitPrice: '单价',
      containerTypeQuantity: '箱型箱量',
      addContainerType: '添加箱型',
      containerType: '箱型',
      quantity: '箱量',
      remove: '删除',
      modal: {
        confirmTitle: '确认修改',
        confirmButton: '确定',
        cancelButton: '取消',
        confirmMessage: '修改箱型箱量可能导致运价变化，请以后续客服确认为准，确认修改？'
      }
    },

    // 订单备注组件
    orderRemarks: {
      title: '订单备注',
      placeholder: '如有特殊要求请在此填写订单备注'
    },

    // 文件上传组件
    fileUpload: {
      defaultTitle: '上传文件',
      defaultTip: '点击或拖拽文件到此区域上传',
      defaultUploadText: '点击或拖拽文件到此区域上传',
      defaultSubText: '最多可上传10个文件',
      uploadLimitReached: '已达到上传数量限制',
      uploadLimitText: '最多可上传 {limit} 个文件，当前已上传 {current} 个',
      uploadLimitWarning: '最多只能上传 {limit} 个文件，请先删除已有文件',
      uploadLimitSize: '单个文件不超过 {maxSize}MB',
      fileNotExists: '文件对象不存在',
      uploadFailed: '上传失败，请重试',
      selectFailed: '选择失败，请重试',
      uploadAction: '上传',
      selectAction: '选择',
      fileUploadFailed: '文件 {fileName} {action}失败: {errorMessage}'
    }
  }
}
